import * as Types from '../constants/actionTypes';

export default (state = {
  assetStatusList: [],
  assetStatusErr: '',
}, action) => {
  switch (action.type) {
    case Types.ASSETS_STATUS_LIST: {
      return {
        ...state,
        assetStatusList: action.payload
      }
    }
    case Types.ASSETS_STATUS_ERROR:
      return {
        ...state,
        assetStatusErr: action.err
      }
    default:
      return state;
  }
};